import React, { useEffect, useRef, useMemo } from 'react'
import ReactDOM from 'react-dom'
import { ImageOverlay } from 'react-leaflet'

import L from 'leaflet'
import PropTypes from 'prop-types'

import filter from 'lodash/filter'
import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'
import toString from 'lodash/toString'

import AnimatedLocation from '@smartcoop/web-components/AnimatedLocation'
import Maps from '@smartcoop/web-components/Maps'

import * as images from './images'

const RainMapFragment = ({ property, style, aggregatedRain, activeTab }) => {
  const mapRef = useRef(null)
  const rainArea = useMemo(
    () => filter(aggregatedRain, item => item.aggregatedPrecipitation > 0),
    [aggregatedRain]
  )

  useEffect(()=> {
    mapRef.current && mapRef.current.leafletElement._onResize()
  }, [mapRef])

  const getImage = rainValue => {
    if (rainValue < 26) return images.red
    if (rainValue >= 26 && rainValue <= 57) return images.orange
    if (rainValue >= 58 && rainValue <= 96) return images.yellow
    if (rainValue >= 97 && rainValue <= 145) return images.green
    if (rainValue >= 146 && rainValue <= 203) return images.blueSky
    if (rainValue >= 204 && rainValue <= 271) return images.blue
    if (rainValue >= 272 && rainValue <= 352) return images.blueOcean
    return images.purple
  }

  const getBounds = (coordinates) => {
    const second = [coordinates[0] - 0.15, coordinates[1] + 0.17]

    return [coordinates, second]
  }

  useEffect(() => {
    if (!mapRef.current.leafletElement || isEmpty(toString(property?.geolocalization?.latitude)) ||isEmpty(toString( property?.geolocalization?.longitude))) return

    const pane = mapRef.current.leafletElement.createPane('marker-rain-map')
    pane.style.zIndex = 650

    // Defina o tamanho do AnimatedLocation (ajuste conforme necessário)
    const iconSize = [50, 50] // Largura e altura do ícone
    const iconAnchor = [50, 50] // Centralizar na coordenada

    const customIcon = L.divIcon({
      html: '<div id="animated-location-rainmap"></div>',
      className: 'custom-icon',
      iconSize,
      iconAnchor // Centraliza o ícone
    })

    const marker = L.marker([property?.geolocalization.latitude, property?.geolocalization.longitude], {
      icon: customIcon,
      pane: 'marker-rain-map'
    }).addTo(mapRef.current.leafletElement)

    setTimeout(() => {
      const container = document.getElementById('animated-location-rainmap')
      if (container) {
        ReactDOM.render(<AnimatedLocation />, container)
      }
    }, 0)

    // eslint-disable-next-line consistent-return
    return () => {
      if (marker) {
        mapRef.current.leafletElement.removeLayer(marker)
      }

      const container = document.getElementById('animated-location-rainmap')
      if (container) {
        ReactDOM.unmountComponentAtNode(container)
      }
    }
  }, [property, mapRef])

  const center = useMemo(() => [-30.0346, -51.2177], [])

  useEffect(() => {
    if (activeTab === 'rain') {
      mapRef.current.leafletElement.invalidateSize()
    }
  }, [activeTab])

  return (
    property?.geolocalization ? (
      <Maps
        zoom={ 6 }
        maxZoom={ 9 }
        center={ center }
        ref={ mapRef }
        layer="streets"
        style={ { zIndex: 1, ...style } }
      >
        { map(rainArea, item => (
          <ImageOverlay
            key={ item.id }
            url={ getImage(item.aggregatedPrecipitation) }
            bounds={ getBounds(item.polygonCoordinates) }
          />
        )) }
      </Maps>
    ) : (
      <div>Carregando</div>
    )

  )
}

RainMapFragment.propTypes = {
  property: PropTypes.object.isRequired,
  style: PropTypes.object,
  activeTab: PropTypes.string,
  aggregatedRain: PropTypes.array
}

RainMapFragment.defaultProps = {
  style: {},
  activeTab: null,
  aggregatedRain: []
}

export default RainMapFragment
